exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Muli:400,700);", ""]);

// module
exports.push([module.id, "html{width:100%;font-size:18px;color:#333}body{margin:0;font-family:Muli,sans-serif}#app,body{height:100%;height:100vh;width:100%}#app{line-height:1.5}.code-text{background:#eee;border:1px solid #ddd;padding:10px 20px;border-radius:4px;margin-bottom:20px;text-align:center}@media (min-width:992px){.code-text{margin-bottom:0}}.btn{text-transform:uppercase;font-weight:700}textarea{min-height:175px}.github-corner:hover .octo-arm{animation:octocat-wave .56s ease-in-out}@keyframes octocat-wave{0%,to{transform:rotate(0)}20%,60%{transform:rotate(-25deg)}40%,80%{transform:rotate(10deg)}}@media (max-width:500px){.github-corner:hover .octo-arm{animation:none}.github-corner .octo-arm{animation:octocat-wave .56s ease-in-out}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54f3c0dd","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./example/App.vue
// module id = 13
// module chunks = 0